export const SET_TRANSLATION_CATEGORY = 'SE_TRANSLATION_CATEGORY';
